
// will be called by consumer. only needed if dlb has holes
var dlbConsumerRequire, dlbConsumerIds;
__webpack_require__.linkDlb = function(require, ids) {
  dlbConsumerRequire = require;
  dlbConsumerIds = ids;
}

// used by consumer to require modules identified in dlb manifest
window["__webpack_require_apollo-dlb/bundle.production.js__"] = __webpack_require__;

// require a module from a DLB consumer. dlbcr = DLB consumer require
// used in modules in this build to require hole modules
__webpack_require__.dlbcr = function(id) {
  if (!dlbConsumerRequire) {
    throw new Error('dlb consumer not properly linked');
  }
  var otherId = dlbConsumerIds[id];
  if (typeof otherId === 'undefined') {
    throw new Error('dlb consumer does not provide module ' + id);
  }
  return dlbConsumerRequire(otherId);
}
